module.exports = "<div id=\"app\">\n  <div><video #video id=\"video\" width=\"640\" height=\"480\" autoplay ></video></div>\n  <div><button id=\"snap\" (click)=\"capture()\">Snap Photo</button></div>\n  <canvas #canvas id=\"canvas\" width=\"640\" height=\"480\"></canvas>\n  <ul>\n    <li *ngFor=\"let c of captures\">\n      <img src=\"{{ c }}\" height=\"600\" width=\"600\" />\n    </li>\n  </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/capture/capture.component.html
// module id = ./src/app/capture/capture.component.html
// module chunks = main